import datasetsApi from './api';
import datasetsLayout from './layout';
import datasetsToasts from './toasts';
import dataModelsApi from '../datamodels/sagas/api';
import dataModelReportsApi from '../reports/sagas/datamodel';
import dataApi from '../data/sagas/api';
import dataToasts from '../data/sagas/toasts';
import attachmentsApi from '../attachments/sagas/api';
import attachmentsToasts from '../attachments/sagas/toasts';
import catalogueSagas from '../catalogue/sagas';
import collectionsApi from '../collections/sagas/api';
import collectionsToasts from '../collections/sagas/toasts';
import conditionsApi from '../conditions/sagas/api';
import conditionsAttachments from '../conditions/sagas/attachments';
import conditionsToasts from '../conditions/sagas/toasts';
import dataModelToasts from '../datamodels/sagas/toasts';
import datasetLinksApi from '../links/sagas/api';
import markdownApi from '../markdown/sagas/api';
import datasetMetricsApi from '../metrics/sagas/api';
import notificationsApi from '../notifications/sagas/api';
import notificationsToasts from '../notifications/sagas/toasts';
import reportsApi from '../reports/sagas/api';
import reportsToasts from '../reports/sagas/toasts';
import datasourceApi from '../datasource/sagas/api';
import datasourceToasts from '../datasource/sagas/toasts';
import settingsApi from '../settings/sagas/api';
import settingsToasts from '../settings/sagas/toasts';
import sharingApi from '../sharing/sagas/api';
import sharingLayout from '../sharing/sagas/layout';
import datasetStatusApi from '../status/sagas/api';
import subscriptionsApi from '../subscriptions/sagas/api';
import dictionariesApi from '../dictionaries/sagas/api';
import dictionaryMarkdownApi from '../dictionaries/markdown/sagas/api';
import dictionaryToasts from '../dictionaries/sagas/toasts';
import namespacesApi from '../namespaces/sagas/api';
import namespacesToasts from '../namespaces/sagas/toasts';
import pmnFunctionsApi from '../pmn-functions/sagas/api';

export default [
  dataModelsApi(),
  dataModelReportsApi(),
  attachmentsApi(),
  attachmentsToasts(),
  ...catalogueSagas,
  collectionsApi(),
  collectionsToasts(),
  conditionsApi(),
  conditionsAttachments(),
  conditionsToasts(),
  dataApi(),
  dataToasts(),
  dataModelToasts(),
  datasetLinksApi(),
  markdownApi(),
  datasetMetricsApi(),
  namespacesApi(),
  namespacesToasts(),
  notificationsApi(),
  notificationsToasts(),
  reportsApi(),
  reportsToasts(),
  settingsApi(),
  settingsToasts(),
  sharingApi(),
  sharingLayout(),
  datasetStatusApi(),
  subscriptionsApi(),
  datasetsApi(),
  datasetsLayout(),
  datasetsToasts(),
  datasourceApi(),
  datasourceToasts(),
  dictionariesApi(),
  dictionaryMarkdownApi(),
  dictionaryToasts(),
  pmnFunctionsApi(),
];
